/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_TitleInputs */

const en_settings_apikeys_title = /** @type {(inputs: Settings_Apikeys_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Keys`)
};

/**
* | output |
* | --- |
* | "API Keys" |
*
* @param {Settings_Apikeys_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_title = /** @type {((inputs?: Settings_Apikeys_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_apikeys_title(inputs)
});
export { settings_apikeys_title as "settings.apikeys.title" }